module.exports = __webpack_public_path__ + "img/the_one_thing.1c91fc66.png";